<template>
  <div class="contractdetail">
    <nav-bar />
    <search-bar />
    <div class="btns fr ac jc">
      <el-button @click="clickGeneratePicture">生成图片</el-button>
    </div>
    <div class="main p30 fz14" v-if="loading" ref="imageDom">
      <div class="fr ac jc mb20 fz18 black bold" style="font-size:18px;">加工定作合同</div>
      <!-- 头部甲定做方 -->
      <div class="fr ac mb20">
        <!-- 承揽方 -->
        <div style="margin-right:40%;">
          <div>
            <span>单据编号：</span>
            <span>{{order_detail.order_no}}</span>
          </div>
          <div>
            <span>定做方：</span>
            <span>{{info.customer.company_name}}</span>
          </div>
          <div>
            <span>承揽方：</span>
            <span>{{info.platform.company_name}}</span>
          </div>
        </div>
        <!-- 定做方 -->
        <div>
          <div>
            <span>采购单号：</span>
          </div>
          <div>
            <span>下单日期：</span>
            <span>{{conversion(order_detail.create_time,"yy-mm-dd")}}</span>
          </div>
          <div>
            <span>联系人：</span>
            <span>{{info.customer.contact_name}}</span>
          </div>
          <div>
            <span>联系人电话：</span>
            <span>{{info.customer.contact_mobile}}</span>
          </div>
        </div>
      </div>
      <!-- 内容 -->
      <div style="font-size:16px;" class="fz16 black bold">一、品名或项目、规格型号、数量、单价、金额</div>

      <table class="data-table">
        <tr>
          <th>商品名称</th>
          <th>
            加工规格
            <br />长×宽(mm)
          </th>
          <th>
            计量
            <br />单位
          </th>
          <th>数量</th>
          <th>单价(元)</th>
          <th>合计(元)</th>
          <th>
            备注
            <br />(接头,封边,机型及加热方式)
          </th>
        </tr>
        <tr v-for="(i,k) in order_detail.orderGoodsBeans" :key="i.order_goods_id" class="nones">
          <td
            class="p20 bor-right"
            :class="{'bor-bottom':k != order_detail.orderGoodsBeans.length-1}"
          >{{i.goods_name}} {{i.goods_standard_name}}</td>
          <td
            class="p10 bor-right"
            :class="{'bor-bottom':k != order_detail.orderGoodsBeans.length-1}"
          >{{Number(i.goods_length*1000)+"*"+i.goods_width*1000+"*"+i.goods_num+"条"}}</td>
          <td
            class="p20 bor-right"
            :class="{'bor-bottom':k != order_detail.orderGoodsBeans.length-1}"
          >平米</td>
          <td
            class="p20 bor-right"
            :class="{'bor-bottom':k != order_detail.orderGoodsBeans.length-1}"
          >{{i.area}}</td>
          <td
            class="p20 bor-right"
            :class="{'bor-bottom':k != order_detail.orderGoodsBeans.length-1}"
          >{{i.goods_price}}</td>
          <td
            class="p20 bor-right"
            :class="{'bor-bottom':k != order_detail.orderGoodsBeans.length-1}"
          >{{i.goods_total_price}}</td>
          <td
            style="text-align:left;"
            class="pl20 bor-bottom"
            :rowspan="order_detail.orderGoodsBeans.length"
            v-if="k == 0"
          >含税价</td>
        </tr>
        <tr>
          <td class="bor-right bor-bottom"></td>
          <td class="bor-right bor-bottom"></td>
          <td class="bor-right bor-bottom"></td>
          <td class="bor-right bor-bottom"></td>
          <td class="bor-right bor-bottom"></td>
          <td class="bor-right bor-bottom"></td>
          <td>
            <div class="itemm" style="text-align:left;">
              <span class="bold">
                以下五项请
                <i class="el-icon-check"></i>
                选:
              </span>
              <div class="fr">
                <span class="bold title">纠偏方式:</span>
                <div class="right">
                  <el-checkbox label="探杆"></el-checkbox>
                  <el-checkbox label="光电"></el-checkbox>
                </div>
              </div>
              <div class="fr">
                <span class="bold title">速度:</span>
                <div class="right">
                  <el-checkbox label="≤20米/每分"></el-checkbox>
                  <el-checkbox label="＞20米/每分"></el-checkbox>
                </div>
              </div>
              <div class="fr">
                <span class="bold title">工作环境:</span>
                <div class="right">
                  <el-checkbox label="湿热蒸汽"></el-checkbox>
                  <el-checkbox label="强酸强碱"></el-checkbox>
                  <el-checkbox label="有机溶剂"></el-checkbox>
                </div>
              </div>
              <div class="fr">
                <span class="bold title">加热方式:</span>
                <div class="right">
                  <el-checkbox label="蒸汽"></el-checkbox>
                  <el-checkbox label="导热油"></el-checkbox>
                  <el-checkbox label="电热管"></el-checkbox>
                  <el-checkbox label="红外"></el-checkbox>
                  <el-checkbox label="天然气"></el-checkbox>
                  <el-checkbox label="电加热"></el-checkbox>
                  <el-checkbox label="燃气"></el-checkbox>
                </div>
              </div>
              <div class="fr">
                <span class="bold title">工作温度:</span>
                <div class="right">
                  <el-checkbox label="≤150°"></el-checkbox>
                  <el-checkbox label="＞150°"></el-checkbox>
                  <el-checkbox label="≥180°"></el-checkbox>
                </div>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td
            colspan="5"
            style="text-align:left;"
            class="pl30"
          >合计金额（大写）： {{digitUppercase(Number(param.order_actual_price))}}</td>
          <td colspan="2" style="text-align:left;" class="pl30">合计：￥{{param.order_actual_price}}</td>
        </tr>
      </table>
      <div class="fr ac mt10">
        <div style="font-size:16px;" class="fz16 black bold">二、交付时间</div>
        <span class="pl30">即日款到{{param.delivery_time}}交货，延误款到，交货顺延。</span>
      </div>
      <div class="fr">
        <div style="font-size:16px;" class="fz16 black bold pl30">交(提)货地点及方式</div>
        <span
          class="pl30"
        >{{info.customer.company_province}}{{info.customer.company_city=='市辖区'?"":info.customer.company_city==info.customer.company_province?"":info.customer.company_city}}{{info.customer.company_country}}{{info.customer.company_address}}</span>
        <span class="pl30">公路</span>
      </div>
      <div class="fr">
        <div style="font-size:16px;" class="fz16 black bold">三、运输及保险承担</div>
        <span class="pl30">以上价格仅包含普通公路件运费</span>
      </div>
      <div class="fr">
        <div style="font-size:16px;" class="fz16 black bold">四、检验标准：</div>
        <span class="pl30">生产商合格标准。</span>
      </div>
      <div style="font-size:16px;" class="fz16 black bold mt10">五、验收标准</div>
      <span
        class="pl30"
      >定做方在收货后如发现产品规格、型号、数量、质量等与本合同约定不符的，应在收到产品之日起7日内以书面形式向承揽方提出；逾期则视为定做方确认产品无异议。承揽方在收到定做方书面提交的异议之日起3日内负责处理，逾期则视为承揽方同意定做方提出的异议及处理意见。</span>
      <div style="font-size:16px;" class="fz16 black bold mb10">六、结算方式及期限</div>
      <table class="data-table">
        <tr>
          <th>款到下单(%)</th>
          <th>款到发货(%)</th>
          <th>货到付款(%)</th>
        </tr>
        <tr>
          <td class="bor-right">{{param.pay_start_proportion}}%</td>
          <td class="bor-right">{{param.pay_ing_proportion}}%</td>
          <td>
            {{param.pay_end_proportion}}%
            <span class="pl10">{{param.pay_day}}天</span>
          </td>
        </tr>
      </table>
      <div class="fr mt10">
        <div style="font-size:16px;" class="fz16 black bold">七、解决合同纠纷方法</div>
        <span class="pl30">协商</span>
      </div>

      <div style="font-size:16px;" class="fz16 black bold mt10">八、双方约定的其他条款(特殊要求请注明):</div>
      <div class="pl30 order_remark">{{order_detail.order_remark}}</div>
      <div class="fr">
        <div style="font-size:16px;" class="fz16 black bold">九、</div>
        <span>如果定做方未按约履行由合同双方共同签订的其他工业皮带【加工定作合同】约定的付款义务则可以视为定做方单方面取消本合同，并承担违约责任，除非双方另有约定。本合同一式两份，自签订日起既具有法律效力，双方各执一份为凭，传真件盖章有效。</span>
      </div>
      <div class="fr">
        <div style="font-size:16px;" class="fz16 black bold">十、</div>
        <span>双方对此合同的内容都有保密义务。</span>
      </div>
      <!-- <div style="font-size:16px;" class="fz16 black bold pt30 pb30">【以下无正文！】</div> -->
      <div class="fr mb20 ml30">
        <!-- 定做方 -->
        <div style="margin-right:30%;">
          <span class="bold">定作方</span>
          <div>
            <span>单位名称(章)：</span>
            <span>{{info.customer.company_name}}</span>
          </div>
          <div>
            <span>单位地址：</span>
            <span>{{info.customer.company_province}}{{info.customer.company_city=='市辖区'?"":info.customer.company_city==info.customer.company_province?"":info.customer.company_city}}{{info.customer.company_country}}{{info.customer.company_address}}</span>
          </div>
          <div>
            <span>法定代表人：</span>
            <!-- <span>{{info.customer.company_name}}</span> -->
          </div>
          <div>
            <span>委托代理人：</span>
            <!-- <span>{{info.customer.company_name}}</span> -->
          </div>
          <div>
            <span>电话：</span>
            <span>{{info.customer.company_tel}}</span>
          </div>
          <div>
            <span>传真：</span>
            <span>{{info.customer.company_fax}}</span>
          </div>
          <div>
            <span>税号：</span>
            <span>{{info.customer.company_taxno}}</span>
          </div>
          <div>
            <span>开户银行：</span>
            <span>{{info.customer.company_bank_name}}</span>
          </div>
          <div>
            <span>账号：</span>
            <span>{{info.customer.company_bank_no}}</span>
          </div>
          <div>
            <span>邮政编码：</span>
            <!-- <span>{{info.customer.company_name}}</span> -->
          </div>
          <div>
            <span>收货人：</span>
            <span>{{info.customer.contact_name}}</span>
          </div>
          <!-- <div>
            <span>收货地址：</span>
            <span>{{info.customer.contact_mobile}}</span>
          </div>-->
        </div>
        <!-- 承揽方 -->
        <div>
          <span class="bold">承揽方</span>
          <!-- <div>
            <span>承揽方：</span>
            <span>{{info.platform.company_name}}</span>
          </div>-->
          <div>
            <span>单位地址：</span>
            <span>{{info.platform.company_address}}</span>
          </div>
          <div>
            <span>代表人：</span>
            <span>{{info.platform.delegate}}</span>
          </div>
          <div>
            <span>电话：</span>
            <span>{{info.platform.company_tel}}</span>
          </div>
          <div>
            <span>传真：</span>
            <span>{{info.platform.company_tel}}</span>
          </div>
          <div>
            <span>网址：</span>
            <span>{{info.platform.company_url}}</span>
          </div>
          <div>
            <span>email：</span>
            <span>{{info.platform.company_email}}</span>
          </div>
          <div class="fz16">
            <span>开户银行：</span>
            <span>{{info.platform.company_bank_name}}</span>
          </div>
          <div class="fz16">
            <span>账号：</span>
            <span class="bold">{{info.platform.company_bank_no}}</span>
          </div>
          <div>
            <span>邮政编码：</span>
            <span>{{info.platform.company_zip_code}}</span>
          </div>
          <div>
            <span>日期：{{conversion(currentdata,3)}}</span>
          </div>
        </div>
      </div>
      <img src="/static/imgs/图层 1.png" class="zhang" alt />
    </div>
    <!-- <img :src="img" alt /> -->
    <footer-bar />
  </div>
</template>

<script>
import html2canvas from "html2canvas";
import NavBar from "@/components/NavBar";
import SearchBar from "@/components/SearchBar";
import FooterBar from "@/components/FooterBar";
import { Loading } from "element-ui";
var loading = null;
export default {
  data() {
    return {
      info: {},
      loading: false,
      order_detail: {},
      param: {},
      currentdata: new Date(),
      img: ""
    };
  },
  watch: {
    order_detail(n) {
      this.param.delivery_time = this.timeago(this.param.delivery_time);
      let order_actual_price = this.param.order_actual_price; //商品修改后价格
      let difference = order_actual_price - n.order_total_price; //差价
      let goods_total_price = n.order_total_price; //全部商品总价格。
      // 每个商品
      n.orderGoodsBeans.forEach(e => {
        let good_total_price = e.goods_actual_price; //当前商品的总价格。 商品价格加工艺价格。当前商品原价
        let area = this.mul(
          e.goods_num,
          this.mul(e.goods_length, e.goods_width)
        );
        // console.log(e.goods_num * e.goods_length * e.goods_width,"面积");

        e.goods_num * e.goods_length * e.goods_width; //面积
        e.area = area;
        let a = this.div(
          this.mul(difference, this.div(good_total_price, goods_total_price)),
          area
        );
        a = this.toDecimal2(a, 4);

        let orgin_goods_unit_price = this.div(good_total_price, area);
        orgin_goods_unit_price = Math.ceil(orgin_goods_unit_price * 100) / 100;
        e.goods_price = this.add(Number(orgin_goods_unit_price), a);
        e.goods_price = Math.ceil(e.goods_price * 100) / 100;
        e.goods_price = this.toDecimal2(e.goods_price);
        e.goods_total_price = this.mul(area, e.goods_price); //单价
        e.goods_total_price = this.toDecimal2(e.goods_total_price);
        this.param.order_actual_price = this.toDecimal2(this.param.order_actual_price);
      });
    }
  },
  created() {
    // this.order_detail = this.getItem("order_detail") || [];
    this.param = this.getItem("param") || {};
    this.getPlatformOrderContract();
    this.getOrderDetail();
  },
  methods: {
    getPlatformOrderContract() {
      this.loading = false;
      this.post("orderInterfaces/v1.0/getPlatformOrderContract", {
        order_id: this.$route.query.id
      }).then(res => {
        this.info = res.data;
        this.loading = true;
      });
    },
    // 订单详情
    getOrderDetail() {
      this.post("orderInterfaces/v1.0/getOrderDetail", {
        order_id: this.$route.query.id
      }).then(res => {
        this.order_detail = res.data;
      });
    },
    clickGeneratePicture() {
      loading = Loading.service({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      html2canvas(this.$refs.imageDom).then(canvas => {
        // 转成图片，生成图片地址
        this.img = canvas.toDataURL("image/png");
        this.uploadBase64Img();
      });
    },
    uploadBase64Img() {
      this.post("settingInterfaces/v1.0/uploadBase64Img", {
        base64: this.img
      }).then(res => {
        loading.close();

        this.set("imgs", res.data);
        this.back();
      });
    }
  },
  components: { NavBar, SearchBar, FooterBar }
};
</script>

<style scoped lang="scss">
.contractdetail {
  font-size: 14px;
  .btns {
    width: 1200px;
    margin: 0 auto;
    padding: 20px 30px;
  }
  .main {
    width: 1200px;
    background-color: #fff;
    margin: 0 auto;
    line-height: 30px;
    position: relative;
    .zhang {
      position: absolute;
      bottom: 170px;
      right: 320px;
    }
    .order_remark {
      width: 100%;
      height: 30px;
      border-bottom: 1px solid #333;
    }
    .data-table {
      width: 100%;
      border: 1px solid #333;
      .bor-right {
        border-right: 1px solid #333;
      }
      .bor-bottom {
        border-bottom: 1px solid #333;
      }
      td {
        text-align: center;
      }
      th {
        vertical-align: middle;
        text-align: center;
        border-bottom: 1px solid #333;
        border-right: 1px solid #333;
        &:last-child {
          border-right: none;
        }
      }
      .itemm {
        width: 360px;
        .title {
          height: 100%;
          text-align: right;
          padding-right: 5px;
          box-sizing: border-box;
          display: inline-block;
          width: 20%;
        }
        .right {
          width: 80%;
          display: inline-block;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/me/myContract/outcontract.vue